import { IntegrationEmailThread } from '../../../models/Email'
import React from 'react'
import { NavLink } from 'react-router-dom'
import buttonStyles from '../../../components/Button/Button.module.scss'
import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'
import { useAppSelector } from '../../../store/hooks'
import { selectCurrentUserEmailIntegration, selectEmailContacts } from '../../../store/emailHub/emailUsers'

export interface EmailFromCellProps {
  thread: IntegrationEmailThread
  onClick: (thread: IntegrationEmailThread) => void
}

export const EmailFromCell: React.FC<EmailFromCellProps> = ({ thread, onClick }) => {
  return (
    <div className='zocks-py-1.25 d-flex gap-2 w-100' onClick={() => onClick(thread)}>
      <EmailFromNames thread={thread} />
      {thread.emails.length > 1 ? <div className='d-flex align-items-center zocks-text-gray-500 text-nowrap'>{thread.emails.length}</div> : null}
    </div>
  )
}

export interface EmailFromNamesProps {
  thread: IntegrationEmailThread
}

const EmailFromNames: React.FC<EmailFromNamesProps> = ({ thread }) => {
  const contacts = useAppSelector(selectEmailContacts)
  const emailIntegration = useAppSelector(selectCurrentUserEmailIntegration)

  const otherSenders = thread.emails.filter((email) => email.sender.email !== emailIntegration?.email).map((email) => email.sender)

  if (!otherSenders.length) {
    return <div className='d-flex align-items-center paragraph-medium-extended'>Unknown</div>
  }

  const uniqueSenders = new Set(otherSenders.map((sender) => sender.email))
  if (uniqueSenders.size === 1) {
    const sender = otherSenders[0]
    const contact = contacts.find((contact) => contact.email?.toLowerCase() === sender.email.toLowerCase())
    if (contact) {
      return (
        <div className='text-truncate'>
          <NavLink
            className={`${buttonStyles.button} ${buttonStyles.linkButton} button-link-medium justify-content-start`}
            to={`/library/manage-contacts/contacts/${contact.id}`}
            target='_blank'
          >
            <div className='paragraph-medium-extended bold text-truncate mw-100'>
              <div className='text-truncate'>{getUserDisplayName(contact)}</div>
            </div>
          </NavLink>
        </div>
      )
    }
    return <div className='d-flex align-items-center text-truncate'>{sender.name || 'Unknown'}</div>
  }

  const firstSender = otherSenders[0]
  const lastDifferentSender = otherSenders.reverse().find((sender) => sender.email !== firstSender.email)

  return (
    <div className='d-flex align-items-center paragraph-medium-extended text-truncate'>
      <div className='text-truncate'>{`${firstSender.name?.split(' ')[0] ?? 'Unknown'}${lastDifferentSender ? `, ..., ${lastDifferentSender.name?.split(' ')[0] ?? 'Unknown'}` : ''}`}</div>
    </div>
  )
}
